import { createRoute } from "@tanstack/react-router";
import type { Delivery } from "@/api/client";
import { requirePermissions } from "@/app/guards";
import { DELIVERIES_PERMISSIONS } from "@/app/nav";
import { DeliveryList } from "@/features/deliveries/DeliveryList";
import { type PageSearch, pageSearch } from "@/routes/paging";
import { staffRoute } from "@/routes/staff";

/** batch is a batch id; q searches name, address or certificate number. */
export type DeliveriesSearch = {
  batch?: string;
  channel?: "email" | "print";
  status?: Delivery["status"];
  q?: string;
} & PageSearch;

const nonEmpty = (value: unknown) => (typeof value === "string" && value.trim() !== "" ? value.trim() : undefined);
const CHANNELS = ["email", "print"] as const;
export const DELIVERY_STATUSES = ["queued", "sending", "sent", "failed", "delivered"] as const;
const oneOf = <T extends string>(allowed: readonly T[], value: unknown) =>
  allowed.find((candidate) => candidate === value);

export const deliveriesRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "deliveries",
  // Set, never omit, each key: the router merges this over the raw query string.
  validateSearch: (search: Record<string, unknown>): DeliveriesSearch => ({
    batch: nonEmpty(search.batch),
    channel: oneOf(CHANNELS, search.channel),
    status: oneOf(DELIVERY_STATUSES, search.status),
    q: nonEmpty(search.q),
    ...pageSearch(search),
  }),
  beforeLoad: ({ context }) => requirePermissions(context.session, DELIVERIES_PERMISSIONS),
  component: DeliveryList,
});
